import React from 'react'
import { Box, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'

/**
 * Shared bottom action bar for plan editing.
 *
 * Mirrors legacy PlanEditTable buttons:
 * [UPDATE PLAN] [UPDATE PLAN AS FUTURE] [NEXT LOCATION] [PREV LOCATION] [NEXT CLASS] [PREV CLASS]
 */
function PlanEditActionBar({
  savingPlan = false,
  saveDisabled = false,
  onUpdate = () => { },
  onUpdateAsFuture = () => { },
  nextLocation = () => { },
  prevLocation = () => { },
  nextClass = () => { },
  prevClass = () => { },
  leftPanelCollapsed = false,
}) {
  const [leftOffset, setLeftOffset] = React.useState(0)

  React.useEffect(() => {
    const updateOffset = () => {
      const targetEl =
        document.getElementById('main-plan-work-screen-card') ||
        document.getElementById('main-plan-monthly-table') ||
        document.querySelector('.v3-plan-table-card') ||
        document.querySelector('.v3-plan-card') ||
        document.querySelector('.main-plan-monthly-table')

      if (targetEl) {
        const rect = targetEl.getBoundingClientRect()
        if (rect.left > 0) {
          setLeftOffset(rect.left)
        }
      }
    }

    updateOffset()
    const timer1 = setTimeout(updateOffset, 100)
    const timer2 = setTimeout(updateOffset, 300)

    window.addEventListener('resize', updateOffset)
    let observer
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(updateOffset)
      observer.observe(document.body)
    }

    return () => {
      clearTimeout(timer1)
      clearTimeout(timer2)
      window.removeEventListener('resize', updateOffset)
      if (observer) observer.disconnect()
    }
  }, [leftPanelCollapsed])

  return (
    <Box
      sx={{
        py: 1,
        px: 1.5,
        position: 'fixed',
        bottom: 0,
        left: leftOffset ? `${leftOffset}px` : (leftPanelCollapsed ? '24px' : '366px'),
        right: 0,
        zIndex: 10,
        backgroundColor: '#f3f4f5',
        borderRadius: '5px 5px 0 0',
        boxShadow: '0 -1px 5px rgb(162 166 187 / 40%)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        transition: 'left 0.15s ease-out',
      }}
    >
      <LoadingButton
        loading={savingPlan}
        onClick={onUpdate}
        variant="contained"
        disabled={savingPlan || saveDisabled}
        data-testid="planner-action-update-plan"
      >
        UPDATE PLAN
      </LoadingButton>

      <LoadingButton
        loading={savingPlan}
        onClick={onUpdateAsFuture}
        variant="contained"
        disabled={savingPlan || saveDisabled}
        data-testid="planner-action-update-plan-as-future"
      >
        UPDATE PLAN AS FUTURE
      </LoadingButton>

      <Button onClick={nextLocation} variant="outlined" data-testid="planner-action-next-location">
        NEXT LOCATION
      </Button>
      <Button onClick={prevLocation} variant="outlined" data-testid="planner-action-prev-location">
        PREV LOCATION
      </Button>
      <Button onClick={nextClass} variant="outlined" data-testid="planner-action-next-class">
        NEXT CLASS
      </Button>
      <Button onClick={prevClass} variant="outlined" data-testid="planner-action-prev-class">
        PREV CLASS
      </Button>
    </Box>
  )
}

export default PlanEditActionBar
